import styled from "@emotion/styled";
import { X, Info } from "phosphor-react";
import { Tooltip } from "@mui/material";

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  overflow-y: scroll;
  background-color: ${(props) => props.theme.cores.surfaceBackground1};
  margin: 0px 40px 80px 40px;

  @media (max-width: 768px) {
    margin: 0px 20px 100px 20px;
    padding-bottom: 110px;
  }
`;

export const ContainerFundoBranco = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.cores.surface2};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  padding: 24px;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

export const ContainerBotaoNovo = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  margin-bottom: 40px;
  gap: 32px;
`;

export const HrEstilizado = styled.hr`
  width: 100%;
  color: ${({ theme }) => theme.cores.textoSimples};
  margin-bottom: 32px;
`;

export const LinhaInputs = styled.div`
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
`;

export const HeaderPopup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 32px;
`;

export const TextoTitulo = styled.h1`
  font-size: 23px;
  font-weight: 500;
  line-height: 25px;
  color: ${({ theme }) => theme.cores.textoSimples};
`;

export const XIcon = styled(X)`
  height: 24px;
  width: 24px;
  color: ${({ theme }) => theme.cores.semanticDanger2};
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    filter: brightness(0.7);
  }
`;

export const ContainerBotoes = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  margin-bottom: 40px;
`;

export const ContainerTextoItemSelecionado = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 32px;
`;

export const TextoItemSelecionadoExcluir = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 16px;
  line-height: 17px;
  color: ${({ theme }) => theme.adaptativo("neutralVariant10", "neutral100")};
`;

export const ContainerBotoesExcluir = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 32px;
  margin-top: 32px;
`;

export const ConteudoPopUp = styled.div`
  min-width: 500px;
  padding-bottom: 10px;

  @media (max-width: 1100px) {
    min-width: 100%;
  }
`;

export const ConteudoPopUpExcluir = styled.div`
  /* min-width: 500px; */
  padding-bottom: 10px;

  @media (max-width: 1100px) {
    min-width: 100%;
  }
`;

export const CustomTooltip = styled(Tooltip)`
  background: transparent;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 99px;
  color: #fff;
`;

export const ContainerTituloSessao = styled.div`
  width: 100%;
  display: flex;
  align-items: start;
  margin-bottom: 24px;
  color: rgba(69, 69, 69, 1);
  background: ${({ theme }) => theme.cores.toastifyInfoFundo};
  gap: 10px;
  padding: 12px;
`;

export const Texto = styled.p`
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  line-height: 17px;
  word-break: normal;
`;

export const TextoBold = styled.span`
  font-weight: bolder !important;
`;

export const IconeInfo = styled(Info)`
  font-size: 24px !important;
`;

export const Linha = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`;
